<template>
	<div
		:class="['c-reading-header', { visible: visible === true }]"
		@click="onClick"
		:data-key="headerKey"
	>
		<div
			class="c-reading-header__sidebar"
			draggable="true"
			@dragstart="onDragstart"
			@dragend="onDragend"
		>
			<avatar
				v-if="avatarUrl"
				:text="getInitials"
				:image="domainImage"
			></avatar>
			<span
				v-if="color"
				:class="['c-reading-header__bucket color', `c${color}`]"
			></span>
		</div>
		<div class="c-reading-header__main">
			<div :class="['center dropdown', { rotate: visible === true }]">
				<chevron-down-icon size="1.5x"></chevron-down-icon>
			</div>
			<h5>
				{{ title }}
			</h5>
			<span class="c-reading-header__subtext">
				<span v-if="composition.text"
					>{{ composition.text }} Highlight{{
						displayText(composition.text)
					}}</span
				>
				<span v-if="composition.code"
					>{{ composition.code }} Code snippet{{
						displayText(composition.code)
					}}</span
				>
				<span v-if="composition.bookmark"
					>{{ composition.bookmark }} Bookmark{{
						displayText(composition.bookmark)
					}}</span
				>
				<span v-if="composition.video"
					>{{ composition.video }} Video highlight{{
						displayText(composition.video)
					}}</span
				>
			</span>
		</div>
	</div>
</template>

<script>
import imgLoader from '@/components/img-loader.vue';
import avatar from '@/components/ui/avatar.vue';
import {
	EyeIcon,
	EyeOffIcon,
	ExternalLinkIcon,
	ChevronDownIcon,
} from 'vue-feather-icons';
import numeral from 'numeral';

export default {
	components: {
		avatar,
		imgLoader,
		EyeIcon,
		EyeOffIcon,
		ExternalLinkIcon,
		ChevronDownIcon,
	},
	data: function () {
		var obj = {
			visible: true,
			_domainImage: false,
			wordCount: 72,
			commentCount: 140,
		};
		return obj;
	},
	props: {
		title: String,
		headerKey: String,
		composition: Object,
		color: Number,
		avatarUrl: String,
	},
	watch: {
		headerKey: {
			handler: function () {
				if (this.$store.getters['ui/isHeaderKeyHidden'](this.headerKey)) {
					this.visible = true;
				} else {
					this.visible = false;
				}
			},
			immediate: true,
		},
		site: function () {
			this._domainImage = this.getDomainImage();
		},
	},
	computed: {
		uiState: function () {
			return this.$store.getters['settings/ui'];
		},
		displayNumber: function () {
			return numeral(this.site.count).format('0,0');
		},
		noteText: function () {
			var len = this.site.count;
			var str = 'Notes';
			if (len === 1) {
				str = 'Note';
			}
			return str;
		},
		domainImage: function () {
			// var url = this._domainImage;
			// if (url) {
			// 	return url;
			// } else {
			// 	this.$store.dispatch('cache/fetchMetadata', this.avatarUrl);
			// 	return null;
			// }
			return `${this.avatarUrl}/favicon.ico`;
		},
		getInitials: function () {
			var href = this.avatarUrl;
			if (!href) {
				return '';
			}
			var gg = href.split('.');
			if (!gg[1]) {
				return href[0] + href[1];
			}
			gg = gg[gg.length - 2];
			return gg[0] + gg[1];
		},
	},
	methods: {
		displayText: function (len) {
			if (len === 1) {
				return '';
			} else {
				return 's';
			}
		},
		onDragend: function (e) {
			this.$store.dispatch('dashboard/dragStopped');
		},
		onDragstart: function (e) {
			this.$store.dispatch('dashboard/dragStarted');
			e.dataTransfer.setData('text', JSON.stringify(this.composition.ids));
		},
		getDomainImage: function () {
			return this.$store.getters['cache/domainImage'](
				'https://' + this.headerKey
			);
		},
		toggleVisibility: function () {
			this.visible = !this.visible;
		},
		onClick: function () {
			this.toggleVisibility();
			this.$store.dispatch('ui/toggleListHeaderState', this.headerKey);
		},
	},
	created: function () {
		this._domainImage = this.getDomainImage();
	},
};
</script>

<style lang="scss">
.c-reading-header {
	display: flex;
	width: 100%;
	height: var(--spacer-lg);
	margin-top: 0;
	margin-bottom: var(--spacer-sm);
	cursor: pointer;

	&__bucket {
		display: inline-block;
		border-radius: var(--border-radius);
		border: none;

		&.color {
			width: var(--spacer);
			height: var(--spacer);
			box-shadow: inset rgb(255 254 255 / 30%) 0 0.3em 0.3em,
				inset rgb(0 0 0 / 20%) 0 -0.1em 0.3em;

			&:not(.c1) {
				border-bottom: 0;
			}
		}
	}

	&__sidebar {
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: $lg-margins * 5;
		cursor: grab;
	}

	&__control {
		width: 40px;
		cursor: pointer;
		user-select: none;

		> span {
			display: block;
			position: absolute;
			top: 12px;
			left: 7px;

			svg {
				display: block;
				stroke: var(--p5);
				stroke-width: 4px;
			}
		}
	}

	&__main {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-left: $lg-margins;
		flex-grow: 1;
		user-select: none;
		flex-direction: column;
		align-items: flex-start;

		h3 {
			font-size: 16px;
			font-weight: 400;
			margin: 0;
			line-height: 1.3;
			opacity: 0.95;
			padding-right: 30px;
		}

		h5 {
			margin-bottom: 0;
			line-height: 1.3;
		}

		span {
			font-size: var(--font-size-sm);
		}

		.dropdown {
			position: absolute;
			display: inline-block;
			top: calc(50% - 12px);
			right: $lg-margins;
			width: 24px;
			height: 24px;
			text-align: center;
			opacity: 0.8;
			border-radius: 50%;
			transition: transform 100ms ease-out;
			transform: rotate(180deg);

			&.rotate {
				transform: rotate(0deg);
			}
		}

		&:hover {
		}
	}

	&__subtext {
		display: block;
		span {
			display: inline-flex;
			align-items: center;
			&:after {
				content: '';
				display: inline-block;
				margin: 0 var(--margin-lg);
				width: var(--margin);
				height: var(--margin);
				background-color: var(--p1);
				border-radius: 50%;
				opacity: 0.75;
			}

			&:last-child {
				&:after {
					content: none;
				}
			}
		}
	}

	&.visible {
		span {
			opacity: 0.75;
		}
	}
}
</style>
